/**
 * Is phone.
 *
 * @param {string} phone
 * @return {boolean}
 */
export function isPhone(phone) {
  return /^\+7[0-9]{10}$/.test(phone);
}
